import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { isAdmin } from '../lib/admin';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    async function handleCallback() {
      try {
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();
        if (sessionError) throw sessionError;
        if (!session) {
          navigate('/login', { replace: true });
          return;
        }

        const { user } = session;
        const meta = user.user_metadata ?? {};

        await supabase.from('profiles').upsert(
          {
            id: user.id,
            username: (user.email ?? '').split('@')[0],
            full_name: (meta.full_name as string) ?? (meta.name as string) ?? '',
            avatar_url: (meta.avatar_url as string) ?? (meta.picture as string) ?? '',
            updated_at: new Date().toISOString(),
          },
          { onConflict: 'id' }
        );

        try {
          const adminStatus = await isAdmin();
          navigate(adminStatus ? '/admin' : '/dashboard', { replace: true });
        } catch {
          navigate('/dashboard', { replace: true });
        }
      } catch (err) {
        console.error('OAuth callback error:', err);
        setError('Authentication failed. Please try again.');
      }
    }

    handleCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-pastel-gradient flex items-center justify-center p-4">
        <div className="w-full max-w-md card-pastel p-10 text-center space-y-4">
          <p className="text-red-600 font-poppins">{error}</p>
          <Link to="/login" className="btn-pastel font-poppins inline-block">
            Back to Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-pastel-gradient flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <svg className="animate-spin h-10 w-10 text-pastel-blue-600" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
        <p className="text-gray-600 font-poppins text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
